// src/components/SmartFlow/nodes/DelayNode.jsx

import React from 'react';
import BaseNode from './base/BaseNode';

/**
 * Delay Node Component
 * Pauses workflow execution for a specified duration
 */
const DelayNode = ({ data, selected }) => {
  const config = data.config || {};

  // Format delay subtitle
  let subtitle = 'Configure delay';
  if (config.delay_seconds) {
    const seconds = config.delay_seconds;
    if (seconds >= 3600) {
      subtitle = `Wait ${Math.floor(seconds / 3600)}h`;
    } else if (seconds >= 60) {
      subtitle = `Wait ${Math.floor(seconds / 60)}m`;
    } else {
      subtitle = `Wait ${seconds}s`;
    }
  } else if (config.delay_minutes) {
    subtitle = `Wait ${config.delay_minutes}m`;
  } else if (config.delay_hours) {
    subtitle = `Wait ${config.delay_hours}h`;
  }

  return (
    <BaseNode
      data={data}
      icon="bi-clock"
      color="#16a085"
      label="Delay"
      subtitle={subtitle}
      hasHandles={{ top: true, bottom: true }}
      selected={selected}
    />
  );
};

export default DelayNode;
